import { create } from "zustand";
import { devtools } from "zustand/middleware";

const useProjectStore = create(
  devtools((set) => ({
    projects: [],
    currentProject: null,
    loading: false,
    pagination: {
      page: 0,
      size: 5,
      totalElements: 0,
    },
    modals: {
      create: false,
      edit: false,
      collaborators: false,
    },
    filters: {},
    setProjects: (projects) => set({ projects }),
    setCurrentProject: (project) => set({ currentProject: project }),
    setLoading: (loading) => set({ loading }),
    setPagination: (pagination) => set({ pagination }),
    setFilters: (filters) => set({ filters }),
    setModalOpen: (modal, isOpen) =>
      set((state) => ({ modals: { ...state.modals, [modal]: isOpen } })),
    openModal: (modal) =>
      set((state) => ({ modals: { ...state.modals, [modal]: true } })),
    closeModal: (modal, clearState = true) =>
      set((state) => ({
        modals: { ...state.modals, [modal]: false },
        currentProject: clearState ? null : state.currentProject,
      })),
  }))
);
export default useProjectStore;
